import App from "./App.vue";
import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import VueI18n from "vue-i18n";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(VueI18n);

import VModal from "vue-js-modal";
Vue.use(VModal);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import { DynamicReactiveRefs } from "vue-reactive-refs";
Vue.use(DynamicReactiveRefs);

Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  },
});

Vue.use(VueCompositionAPI);

const messages = {
  en: {
    booth: "Voting booth",
    boothFor: "Voting booth for {name}",
    finalize: "Finalize",
    logout: "Logout",
    question: "Question",
    questionNext: "Next question",
    questionPrev: "Previous question",
    results: "Results:",
    retry: "Retry",
    start: "Start",
    submit: "Submit",
    tally: "Tally",
    title: "Election server",
    welcome: "Welcome",
    _loading: {
      election: "Loading election…",
    },
    _notFound: {
      election: "Election doesn't exist.",
    },
    _results: {
      downloadElectionData: "Download election data",
      downloadTallyFingerprints: "Download tally fingerprint",
      downloadTally: "Download tally",
      electionFingerprintIs: "The fingerprint of the election is:",
      serverFingerprintIs: "The fingerprint of the voting server is:",
      tallyDescription:
        "The tally has {votersCount} voters and its fingerprint is:",
      tallyTime: "Tally time:",
      talliedVotes: "Votes:",
      talliedBallots: "Tallied ballots:",
      tallyBallots: "Ballots:",
      trustees:
        "All the following trustees verification keys are required to decrypt the tally:",
      trusteesThreshold:
        "At least {threshold} of the following trustee verification keys are required to decrypt the tally:",
    },
    _vote: {
      alreadyVoted: "You already voted for this election.",
      ballotFingerprintIs: "Its fingerprint is:",
      between:
        "between {min} and {max} answer | between {min} and {max} answers",
      blank: "Vote blank",
      blankVote: "Blank vote",
      blankOr: "or vote blank",
      check:
        "You can check it is present in the tally at any point and check the election fingerprints by reconnecting to this voting page.",
      code: "Please enter your private code",
      codeGet: "Get your code",
      data: "Please enter your personal data code",
      downloadBallot: "Download ballot",
      encrypting: "Encrypting ballot…",
      failed: "Ballot validation failure",
      fallbackPhone: "Please enter your mobile phone number",
      key: "Please enter your private key to encrypt your ballot",
      exactly: "exactly {n} anwser | exactly {n} answers",
      notPublished:
        "This election is not published, you can't submit your ballot.",
      pick: "You must pick",
      pickedCurrently:
        "You have picked {n} answer | You have picked {n} answer",
      ready: "Your ballot is ready",
      submitting: "Submitting ballot…",
      success: "Ballot submitted!",
      successLong: "Congratulations, your ballot was submitted successfully.",
      summary: "Your picks",
      tallied: "The election has been tallied.",
      testBooth:
        "Le scrutin n'est pas encore publié et il s'agit d'un isoloir de test, vous ne pourrez pas soumettre ce bulletin.",
      tooLate: "The vote was closed on {time}.",
      tooSoon: "The vote will open on {time}.",
      votesCount:
        "You will need your private key to sign your ballot at the end of the process. | You have {n} votes for this election. You will need your private key to sign your ballot at the end of the process.",
    },
  },
  fr: {
    booth: "Isoloir de vote",
    boothFor: "Isoloir de vote pour {name}",
    finalize: "Finaliser",
    logout: "Déconnexion",
    question: "Résolution",
    questionNext: "Résolution suivante",
    questionPrev: "Résolution précédente",
    results: "Résultats :",
    retry: "Réessayer",
    start: "Commencer",
    submit: "Soumettre",
    tally: "Urne",
    title: "Serveur de scrutin",
    welcome: "Bienvenue",
    _loading: {
      election: "Chargement du scrutin …",
    },
    _notFound: {
      election: "Ce scrutin n'existe pas.",
    },
    _results: {
      downloadElectionData: "Télécharger les données de l'élection",
      downloadTallyFingerprints: "Télécharger l'empreinte de l'urne",
      downloadTally: "Télécharger les bulletins",
      electionFingerprintIs: "L'empreinte numérique du scrutin est :",
      serverFingerprintIs: "L'empreinte numérique du serveur de vote est :",
      tallyDescription:
        "La liste d'émargement comporte {votersCount} votants et a pour empreinte numérique :",
      tallyTime: "Date de dépouillement :",
      talliedVotes: "Voix exprimées :",
      talliedBallots: "Bulletins dépouillés :",
      tallyBallots: "Bulletins dans l'urne :",
      trustees:
        "Toutes les autorités de confiance suivantes (clés de vérification) sont nécessaires pour déchiffrer le résultat :",
      trusteesThreshold:
        "Au moins {threshold} des autorités de confiance suivantes (clés de vérification) sont nécessaires pour déchiffrer le résultat :",
    },
    _vote: {
      alreadyVoted: "Vous avez déjà voté pour ce scrutin.",
      ballotFingerprintIs: "Son numéro de suivi est :",
      between: "entre {min} et {max} réponse | entre {min} et {max} réponses",
      blank: "Voter blanc",
      blankVote: "Vote Blanc",
      blankOr: "ou voter blanc",
      check:
        "Vous pouvez à tout moment vérifier sa présence dans l'urne et consulter les empreintes du scrutin en vous reconnectant sur la page de vote.",
      code: "Veuillez saisir votre code secret ci-dessous",
      codeGet: "Recevoir votre code",
      data: "Veuillez saisir votre donnée personnelle ci-dessous",
      downloadBallot: "Télécharger le bulletin",
      encrypting: "Chiffrement du bulletin …",
      failed: "Échec de validation du bulletin",
      fallbackPhone: "Veuillez saisir votre numéro de téléphone portable",
      exactly: "exactement {n} réponse | exactement {n} réponses",
      key:
        "Veuillez saisir votre clé privée ci-dessous pour chiffrer votre bulletin",
      notPublished:
        "Ce scrutin n'est pas publié, impossible de soumettre le bulletin.",
      pick: "Vous devez choisir",
      pickedCurrently:
        "Vous avez choisi {n} réponse | Vous avez choisi {n} réponses",
      ready: "Votre bulletin de vote est prêt à être soumis",
      submitting: "Soumission du bulletin …",
      success: "Bulletin soumis !",
      successLong: "Félicitations, votre bulletin a été pris en compte.",
      summary: "Récapitulatif des votes",
      tallied: "Le scrutin a été dépouillé.",
      testBooth:
        "Le scrutin n'est pas encore publié et il s'agit d'un isoloir de test, vous ne pourrez pas soumettre ce bulletin.",
      tooLate: "Le vote a été clos le {time}.",
      tooSoon: "Le vote ouvrira le {time}.",
      votesCount:
        "Votre clé privée sera nécessaire au terme du vote pour signer votre bulletin. | Vous disposez de {n} voix pour ce scrutin. Votre clé privée sera nécessaire au terme du vote pour signer votre bulletin.",
    },
  },
};

const dateTimeFormat = {
  short: {
    year: "numeric",
    month: "short",
    day: "numeric",
  },
  long: {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
    hour: "numeric",
    minute: "numeric",
  },
};

const dateTimeFormats = {
  en: dateTimeFormat,
  fr: dateTimeFormat,
};

const i18n = new VueI18n({
  dateTimeFormats,
  locale: "fr",
  messages,
});
document.documentElement.lang = "fr";

store.then(store => {
  const vue = new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
  }).$mount("#app");

  vue.$on("setLocale", (locale: string) => {
    i18n.locale = locale;
    document.documentElement.lang = locale;
  });
});

export function formatTime(date: Date) {
  const dateRepr = date.toLocaleDateString("fr-FR");
  const time = date.toLocaleTimeString("fr-FR");
  return `${dateRepr} ${time}`;
}
